export const DotBar = ({ percentage, dotId }) => {
  return (
    <div className="dot-bar">
      <div className="line"></div>
      <div className="dot" id={`${dotId}`} style={{ left: `${percentage}%` }} />
    </div>
  );
};
